
export type MediaInfoDimensions = {
  height?: number;
  width?: number;
};
